enum AllPermissionAccessStatus {
  All = 'all',
  Restricted = 'restricted',
}

export default AllPermissionAccessStatus;
